/**
 * Click-triggered popover anchored to a trigger element.
 */
import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

/**
 * Opens a MUI Popover when the trigger is clicked.
 *
 * @param {{ trigger: React.ReactNode, children: React.ReactNode }} props
 */
const BPopOver = (props) => {
  const { trigger, children, ...rest } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  /**
   * Anchors the popover to the clicked trigger.
   *
   * @param {React.MouseEvent} event Click event.
   * @returns {void}
   */
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  /**
   * Closes the popover.
   *
   * @returns {void}
   */
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Box onClick={handleClick} {...rest}>
        {trigger}
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {children}
      </Popover>
    </>
  );
};

BPopOver.propTypes = {
  trigger: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};

export default BPopOver;
